import { render, staticRenderFns } from "./WarningRed.vue?vue&type=template&id=0ced3ecc"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ced3ecc')) {
      api.createRecord('0ced3ecc', component.options)
    } else {
      api.reload('0ced3ecc', component.options)
    }
    module.hot.accept("./WarningRed.vue?vue&type=template&id=0ced3ecc", function () {
      api.rerender('0ced3ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/WarningRed.vue"
export default component.exports